<template>
  <div class="faq-section">
    <div class="container-fluid px-0">
      <div class="faq-header">
        <h2 class="faq-title">DAŽNIAUSIAI UŽDUODAMI KLAUSIMAI</h2>
        <div class="faq-divider"></div>
        <p class="faq-subtitle">Turite klausimų? Raskite atsakymus čia</p>
      </div>

      <div class="faq-container">
        <div 
          v-for="(item, index) in faqItems" 
          :key="index"
          class="faq-item"
          :class="{ 'faq-item-active': activeIndex === index }"
        >
          <button 
            class="faq-question"
            @click="toggleFaq(index)"
          >
            <span class="faq-question-text">{{ item.question }}</span>
            <svg 
              class="faq-icon"
              :class="{ 'faq-icon-rotated': activeIndex === index }"
              xmlns="http://www.w3.org/2000/svg" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          <div 
            class="faq-answer"
            :class="{ 'faq-answer-visible': activeIndex === index }"
          >
            <p class="faq-answer-text">{{ item.answer }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FAQ',
  props: {
    type: {
      type: String,
      default: 'auto', // 'auto' or 'digging'
      validator: (value) => ['auto', 'digging'].includes(value)
    }
  },
  data() {
    return {
      activeIndex: null
    }
  },
  computed: {
    faqItems() {
      if (this.type === 'auto') {
        return [
          {
            question: 'Kiek laiko užtrunka automobilio remontas?',
            answer: 'Remonto laikas priklauso nuo gedimo sudėtingumo. Paprasti darbai (pvz., tepalų keitimas) užtrunka 30-60 minučių, o sudėtingesni remontai gali užtrukti kelias dienas. Visada informuojame klientus apie numatomą remonto laiką.'
          },
          {
            question: 'Kokios jūsų paslaugų kainos?',
            answer: 'Kainos priklauso nuo atliekamų darbų sudėtingumo ir reikalingų dalių. Siūlome nemokamą diagnostiką, jei nutariate palikti automobilį peržiūrai pas mus. Susisiekite su mumis, kad gautumėte tikslų kainos pasiūlymą.'
          },
          {
            question: 'Ar turite garantiją už atliktus darbus?',
            answer: 'Taip, visiems atliktiems darbams suteikiame garantiją. Garantijos terminas priklauso nuo darbo tipo ir naudotų dalių. Detalią informaciją apie garantiją pateikiame kiekvienam klientui.'
          },
          {
            question: 'Ar galite remontuoti visų markių automobilius?',
            answer: 'Taip, turime patirtį dirbant su įvairių markių automobiliais – tiek lengvaisiais, tiek sunkiasvoriais. Mūsų specialistai turi reikalingą patirtį ir įrankius daugumai automobilių markių.'
          },
          {
            question: 'Kokios jūsų darbo valandos?',
            answer: 'Dirbame pirmadienį–penktadienį nuo 08:00 iki 17:00. Skubiais atvejais galime aptarti individualius sprendimus. Susisiekite su mumis telefonu, kad suderintume laiką.'
          }
        ]
      } else {
        return [
          {
            question: 'Kokius žemės kasimo darbus atliekate?',
            answer: 'Atliekame visus žemės kasimo darbus: sklypų kasimą, tvenkinių kasimą, griovių kasimą, žemės lyginimą ir formavimą. Turime reikalingą techniką ir patirtį bet kokio sudėtingumo projektams.'
          },
          {
            question: 'Kokios jūsų paslaugų kainos?',
            answer: 'Kainos priklauso nuo projekto apimties, žemės tipo ir sudėtingumo. Siūlome nemokamą konsultaciją ir kainos pasiūlymą. Susisiekite su mumis, kad gautumėte individualų pasiūlymą.'
          },
          {
            question: 'Kiek laiko užtrunka projektas?',
            answer: 'Projekto trukmė priklauso nuo jo apimties ir sudėtingumo. Paprastesni darbai gali būti atlikti per dieną, o didesni projektai gali užtrukti kelias savaites. Visada pateikiame numatomą projekto trukmę.'
          },
          {
            question: 'Ar dirbate visoje Lietuvoje?',
            answer: 'Taip, teikiame paslaugas visoje Lietuvos teritorijoje. Turime mobilųjį parką, todėl galime atvykti į bet kurią vietą. Susisiekite su mumis dėl konkretaus projekto.'
          },
          {
            question: 'Kokios jūsų darbo valandos?',
            answer: 'Dirbame pirmadienį–penktadienį nuo 08:00 iki 17:00. Dideliems projektams galime dirbti ilgiau. Susisiekite su mumis, kad suderintume darbo grafiką.'
          }
        ]
      }
    }
  },
  methods: {
    toggleFaq(index) {
      this.activeIndex = this.activeIndex === index ? null : index
    }
  }
}
</script>

<style scoped>
.faq-section {
  background: white;
  padding: 80px 20px;
}

.faq-header {
  text-align: center;
  margin-bottom: 60px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.faq-title {
  font-family: 'Montserrat', sans-serif;
  font-size: clamp(2rem, 4vw, 2.5rem);
  font-weight: 800;
  color: #1a1a1a;
  margin-bottom: 20px;
  letter-spacing: -0.02em;
}

.faq-divider {
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #dc3545, #ff6b6b);
  border-radius: 2px;
  margin: 0 auto 20px;
}

.faq-subtitle {
  font-family: 'Open Sans', sans-serif;
  font-size: 1.1rem;
  color: #6c757d;
  margin: 0;
}

.faq-container {
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.faq-item {
  background: white;
  border-radius: 12px;
  border: 2px solid #f0f0f0;
  overflow: hidden;
  transition: all 0.3s ease;
}

.faq-item:hover {
  border-color: #dc3545;
  box-shadow: 0 4px 15px rgba(220, 53, 69, 0.1);
}

.faq-item-active {
  border-color: #dc3545;
  box-shadow: 0 8px 25px rgba(220, 53, 69, 0.15);
}

.faq-question {
  width: 100%;
  padding: 24px 30px;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  font-family: 'Montserrat', sans-serif;
  transition: all 0.3s ease;
}

.faq-question:hover {
  background: #f8f9fa;
}

.faq-question-text {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1a1a1a;
  flex: 1;
}

.faq-icon {
  width: 24px;
  height: 24px;
  color: #dc3545;
  transition: transform 0.3s ease;
  flex-shrink: 0;
}

.faq-icon-rotated {
  transform: rotate(180deg);
}

.faq-answer {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
  padding: 0 30px;
}

.faq-answer-visible {
  max-height: 500px;
  padding: 0 30px 24px 30px;
}

.faq-answer-text {
  font-family: 'Open Sans', sans-serif;
  font-size: 1rem;
  line-height: 1.7;
  color: #6c757d;
  margin: 0;
  padding-top: 16px;
}

@media (max-width: 768px) {
  .faq-section {
    padding: 60px 15px;
  }
  
  .faq-question {
    padding: 20px;
  }
  
  .faq-question-text {
    font-size: 1rem;
  }
  
  .faq-answer-visible {
    padding: 0 20px 20px 20px;
  }
}
</style>

